import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authGuard, guestGuard } from './guards/auth.guard';

import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';

import { LoginPageComponent } from './pages/login-page/login-page.component';
import { PulsePageComponent } from './pages/pulse-page/pulse-page.component';
import { ExplorePageComponent } from './pages/explore-page/explore-page.component';
import { VoicePageComponent } from './pages/voice-page/voice-page.component';
import { ActionsPageComponent } from './pages/actions-page/actions-page.component';
import { ProgramPageComponent } from './pages/program-page/program-page.component';

/**
 * Cinco secciones, una por pregunta del programa. El detalle de cada una vive en
 * pestañas internas, no en rutas sueltas: asi el menu se mantiene abarcable.
 *
 * Todo el tablero cuelga de `authGuard`, asi que sin sesion cualquier ruta
 * —incluida una guardada en marcadores— aterriza en `/acceso`. La pantalla de
 * acceso lleva el guardia inverso: con sesion abierta no tiene nada que ofrecer.
 *
 * Las rutas del tablero anterior se conservan como redirecciones para no romper
 * enlaces guardados.
 */
const routes: Routes = [
  {
    path: 'acceso',
    component: LoginPageComponent,
    canActivate: [guestGuard],
    title: 'Acceso',
  },

  { path: '', redirectTo: 'pulso', pathMatch: 'full' },

  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      { path: 'pulso',    component: PulsePageComponent,   title: 'Pulso' },
      { path: 'explorar', component: ExplorePageComponent, title: 'Explorar' },
      { path: 'voz',      component: VoicePageComponent,   title: 'Voz del cliente' },
      { path: 'acciones', component: ActionsPageComponent, title: 'Acciones' },
      { path: 'programa', component: ProgramPageComponent, title: 'Programa' },
    ],
  },

  /* compatibilidad con las rutas del tablero anterior */
  { path: 'home',              redirectTo: 'pulso' },
  { path: 'dashboard',         redirectTo: 'explorar' },
  { path: 'resultados',        redirectTo: 'explorar' },
  { path: 'detalle-tiendas',   redirectTo: 'voz' },
  { path: 'resultados-tienda', redirectTo: 'explorar' },
  { path: 'close-loop',        redirectTo: 'acciones' },
  { path: 'planes-accion',     redirectTo: 'acciones' },
  { path: 'salud',             redirectTo: 'programa' },
  { path: 'text-analytics',    redirectTo: 'voz' },
  { path: 'glosario',          redirectTo: 'programa' },

  { path: '**', redirectTo: 'pulso' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
